module.exports = __webpack_public_path__ + "static/img/noBanner.8b0b738.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noBanner.jpg
// module id = Jf1e
// module chunks = 2